import moment from "moment/moment";
import { useSelector } from "react-redux";


export function minToHoursAndMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${padToTwoDigits(hours, true)}:${padToTwoDigits(minutes, false)}`;
}

export function padToTwoDigits(num, isSigned) {
    let signed
    if (num.toString().includes("-")) {
        signed = "-"
    } else {
        signed = "+"
    }
    return `${isSigned ? signed : ""}${Math.abs(num).toString().padStart(2, '0')}`;
}
export function useGetTimezoneTimeOffset(timezone) {
    const timeZoneRedux = useSelector((state) => state.appGlobal.timezone)

    let _timeZone = timezone || timeZoneRedux
    const offset = moment().tz(_timeZone).utcOffset();
    return (minToHoursAndMinutes(offset))

}